<template>
  <tr>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="flex flex-col"
        v-if="item.vehicle">
        <div :class="{'text-sm text-gray-900' : !hasEvent, 'text-sm text-gray-400' : hasEvent }">
          {{ item.vehicle.code }}
        </div>
      </div>
      <div class="flex flex-col"
        v-else>
        <div class="text-sm text-red-500">
          Vehicle Missing
        </div>
      </div>
    </td>
    <!-- <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">
        {{ item.route.window_sign }}
      </div>
    </td> -->
    <td class="px-2 py-2 whitespace-nowrap"
      v-if="showNumber">
      <div :class="{'text-sm text-gray-900' : !hasEvent, 'text-sm text-gray-400' : hasEvent }">
        {{ item.route.number }}
      </div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div :class="{'text-sm text-gray-900' : !hasEvent, 'text-sm text-gray-400' : hasEvent }">
        {{ item.routeDirection }}
      </div>
    </td>
    <td v-if="showStatus" class="px-2 py-2 whitespace-nowrap">
      <div class="flex flex-row items-center" :class="{'text-sm text-gray-900' : !hasEvent, 'text-sm text-gray-400' : hasEvent }">
        <Spinner
          v-if="!item.status"
          :size="6"
        />
        {{ statusDisplay }}
        <div v-if="!isPreviousDay && item.delayed && item.status == 'not_started' && showDelayed == true && !hasEvent"
          title="Route is delayed 10+ mins">
          <svg
            class="h-6 w-6 mx-1 text-red-600"
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg" 
            stroke="currentColor">
            <path 
              d="M12 16.99V17M12 7V14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
              stroke="currentColor"  
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round">
            </path>
          </svg>
        </div>
        <div v-if="!isPreviousDay && item.delayed && item.status != 'not_started' && item.status != undefined && !hasEvent"
          title="Route is delayed 10+ mins">
          <svg
            class="h-6 w-6 mx-1 text-yellow-400"
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg" 
            stroke="currentColor">
            <path 
              d="M12 16.99V17M12 7V14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
              stroke="currentColor"  
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round">
            </path>
          </svg>
        </div>
      </div>
    </td>
    <td class="px-2 py-2 whitespace-normal">
      <div class="flex flex-col"
        v-if="item.building">
        <div :class="{'text-sm text-gray-900' : !hasEvent, 'text-sm text-gray-400' : hasEvent }">
          {{ item.building.name }}
        </div>
        <div class="pl-2 text-sm w-48"
          :class="{'text-gray-500' : !hasEvent, 'text-gray-400' : hasEvent }">
          {{ `${item.building.address.street}, ${item.building.address.city}, ${item.building.address.state} ${item.building.address.zip_code}` }}
        </div>
      </div>
      <div class="text-sm text-red-500"
        v-else>
        Building Missing
      </div>
    </td>
    <td class="px-2 py-2 whitespace-normal"
      v-if="showRouteDetail">
      <RouteDetailModal
        :title="routeDetailTitle"
        :routeId="item.route.db_id"
        :date="date"
        :direction="item.routeDirection"
        :students="studentDataUnique"
        :showRouteTimes="showRouteTimes"
      />
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div :class="{'text-sm text-gray-900' : !hasEvent, 'text-sm text-gray-400' : hasEvent }"
        v-if="item.schedule[weekdayString]?.start_time">
        <span class="text-gray-300 uppercase">{{ weekdayString }}</span>
        {{ timeToDisplay(item.schedule[weekdayString]?.start_time) }}
      </div>
      <div class="text-sm text-gray-300"
        v-else>
        ---
      </div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div :class="{'text-sm text-gray-900' : !hasEvent, 'text-sm text-gray-400' : hasEvent }"
        v-if="item.schedule[weekdayString]?.end_time">
        <span class="text-gray-300 uppercase">{{ weekdayString }}</span>
        {{ timeToDisplay(item.schedule[weekdayString]?.end_time) }}
      </div>
      <div class="text-sm text-gray-300"
        v-else>
        ---
      </div>
    </td>
    <td class="px-2 py-2 whitespace-normal">
      <div class="flex flex-row gap-2">
        <div>
          <Modal
            size="md"
            width="4">
            <template #button="slotProps">
              <button
                type="button"
                @click="() => slotProps.openModal()"
                class="text-gray-600 hover:text-gray-900">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </button>
            </template>
            <template #title>Schedule</template>
            <template #content>
              <Table>
                <template #columns>
                  <th
                    v-for="(column, index) in scheduleColumns"
                    :key="index"
                    scope="col"
                    class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                    {{ column }}
                  </th>
                </template>
                <template #rows>
                  <tr v-for="scheduleObj in orderedSchedule" :key="scheduleObj.weekday">
                    <td class="px-2 py-2 whitespace-nowrap">
                      <div class="text-sm text-gray-900">
                        {{ scheduleObj.weekday }}
                      </div>
                    </td>
                    <td class="px-2 py-2 whitespace-nowrap">
                      <div class="text-sm"
                        v-if="scheduleObj.timeInfo.start_time">
                        {{ timeToDisplay(scheduleObj.timeInfo.start_time) }}
                      </div>
                      <div class="text-sm text-gray-300"
                        v-else>
                        ---
                      </div>
                    </td>
                    <td class="px-2 py-2 whitespace-nowrap">
                      <div class="text-sm"
                        v-if="scheduleObj.timeInfo.end_time">
                        {{ timeToDisplay(scheduleObj.timeInfo.end_time) }}
                      </div>
                      <div class="text-sm text-gray-300"
                        v-else>
                        ---
                      </div>
                    </td>
                  </tr>
                </template>
              </Table>
            </template>
          </Modal>
        </div>
        <div class="text-xs text-gray-500 w-36">
          <span
            v-for="scheduleDay in scheduleToDays.slice(0, scheduleToDays.length - 1)"
            :key="scheduleDay"
            :class="{
              'font-bold': scheduleDay === weekdayString.toUpperCase(),
              'text-gray-900': scheduleDay === weekdayString.toUpperCase(),
            }">
            {{ scheduleDay }},
          </span>
          <span
            :class="{
              'font-bold': scheduleToDays.at(-1) === weekdayString.toUpperCase(),
              'text-gray-900': scheduleToDays.at(-1) === weekdayString.toUpperCase(),
            }">
            {{ scheduleToDays.at(-1) }}
          </span>
        </div>
      </div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="flex gap-1 flex-wrap max-w-6xl">
        <Tag
          v-for="accommodation in accommodations.filter(
            accommodation => item.accommodations[accommodation.name]
          )"
          :key="accommodation.name"
          :backgroundColor="accommodation.backgroundColor"
          :textColor="accommodation.textColor ? accommodation.textColor : 'black'"
        >
          {{ accommodation.text }}
        </Tag>
      </div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap text-center">
      <Modal
        size="md"
        width="4">
        <template #button="slotProps">
          <button
            type="button"
            @click="() => slotProps.openModal()"
            class="text-gray-600 hover:text-gray-900"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          </button>
        </template>
        <template #title>Students</template>
        <template #content>
          <RouteStudentList
            :students="studentDataUnique"
            :accommodations="accommodations"
          />
        </template>
      </Modal>
    </td>
  </tr>
</template>

<script>
import Modal from '../Modal.vue'
import Table from '../Table.vue'
import Tag from '../Tag.vue'
import Spinner from '../Spinner.vue'
import RouteDetailModal from '../modals/RouteDetailModal.vue'
import RouteStudentList from '../RouteList/RouteStudentList.vue'

import time from '../../services/utils/time.js'

const WEEKDAY_MAP = {
  0: 'sun',
  1: 'mon',
  2: 'tue',
  3: 'wed',
  4: 'thu',
  5: 'fri',
  6: 'sat',
}
const WEEKDAY_ORDER = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
const WEEKDAY_DISPLAY = {
  'sun': 'Sunday',
  'mon': 'Monday',
  'tue': 'Tuesday',
  'wed': 'Wednesday',
  'thu': 'Thursday',
  'fri': 'Friday',
  'sat': 'Saturday',
}

export default {
  components: {
    Modal,
    Table,
    Tag,
    Spinner,
    RouteDetailModal,
    RouteStudentList,
  },
  props: {
    item: Object,
    date: String,
    weekday: Number,
    showOriginTime: {
      type: Boolean,
      default: true,
    },
    showDestinationTime: {
      type: Boolean,
      default: true,
    },
    showRouteDetail: {
      type: Boolean,
      default: false,
    },
    showNumber: {
      type: Boolean,
      default: false,
    },
    showDelayed: {
      type: Boolean,
      default: false,
    },
    showStatus: {
      type: Boolean,
      default: true,
    },
    isPreviousDay: {
      type: Boolean,
      default: false,
    },
    showRouteTimes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      STATUS_DISPLAY_MAP: {
        undefined: 'Unknown',
        'error': 'Error',
        'running': 'In Progress',
        'not_started': 'Not started',
        'complete': 'Completed',
        'no_riders': 'No Students Riding',
        'off': 'Off for the day',
      },
      scheduleColumns: ['Weekday', 'Start Time', 'End Time'],
      accommodations: [
        {
          name: 'aide',
          text: 'Aide',
          backgroundColor: '#FCA5A5'
        },
        {
          name: 'solo',
          text: 'Solo',
          backgroundColor: '#FC0000',
          textColor: 'white',
        },
        {
          name: 'wheelchair',
          text: 'Wheelchair',
          backgroundColor: '#FCD34D'
        },
        {
          name: 'boosterSeat',
          text: 'Booster seat',
          backgroundColor: '#6EE7B7'
        },
        {
          name: 'safetyVest',
          text: 'Safety vest',
          backgroundColor: '#93C5FD'
        },
        {
          name: 'safetyBeltLockingCover',
          text: 'Safety belt locking cover',
          backgroundColor: '#A5B4FC'
        },
        {
          name: 'carSeat',
          text: 'Car seat',
          backgroundColor: '#C4B5FD'
        }
      ],
    }
  },
  methods: {
    timeToDisplay(_time) {
      return time.timeToDisplay(_time)
    },
    scheduleToDisplay(scheduleObj) {
      let retString = ''
      for (const day of WEEKDAY_ORDER) {
        if (scheduleObj[day]) {
          if (retString) {
            retString += ', '
          }
          retString += day.toUpperCase()
        }
      }
      return retString
    },
    openStudentDetail(internalId) {
      let dbId = this.item.studentData[this.item.studentData.findIndex(e => e.internalId == internalId)].dbId
      if (this.selected < 0) {
        return
      }
      const routeData = this.$router.resolve({
        name: 'StudentHistory',
        params: {
          studentDbId: dbId
        }
      })
      console.log(routeData.href)
      window.open(routeData.href, '_blank')
    }
  },
  computed: {
    weekdayString() {
      return WEEKDAY_MAP[this.weekday]
    },
    orderedSchedule() {
      let ordered = []
      for (const day of WEEKDAY_ORDER) {
        if (this.item.schedule[day]) {
          ordered.push({
            weekday: WEEKDAY_DISPLAY[day],
            timeInfo: this.item.schedule[day]
          })
        }
      }
      return ordered
    },
    scheduleToDays() {
      let days = []
      for (const day of WEEKDAY_ORDER) {
        if (this.item.schedule[day]) {
          days.push(day.toUpperCase())
        }
      }
      return days
    },
    routeDetailTitle() {
      let buildingName
      if (!this.item.building) {
        buildingName = 'Missing Building/Program'
      }
      else {
        buildingName = this.item.building.name
      }
      if (!this.item.vehicle) {
        return `N/A - ${this.item.routeDirection} - ${buildingName}`
      }
      return `${this.item.vehicle.code} - ${this.item.route.number} - ${this.item.routeDirection} - ${buildingName}`
    },
    studentDataUnique() {
      let existingIds = {}
      return this.item.studentData.filter(curr => {
        if (existingIds[curr.internalId] === undefined) {
          existingIds[curr.internalId] = true
          return true
        }
        else {
          return false
        }
      })
    },
    hasEvent() {
      return this.item.event !== undefined || this.item.status === 'off'
    },
    statusDisplay() {
      if (this.isPreviousDay && this.item.status === 'running') {
        return 'Left in Progress'
      }

      return this.STATUS_DISPLAY_MAP[this.item.status]
    },
  },
  mounted() {
    // do nothing
  }
}
</script>

<style></style>
